import "./App.css";

import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <h1>Dictionary</h1>
        </header>
        <main>
          <Dictionary defaultKeyword="beach" />
        </main>
        <footer className="App-footer">
          - Coded by M J Elwood | Open-sourced on{" "}
          <a
            href="https://github.com/mjeanelwood/dictionary-app-fp"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a>{" "}
          | Hosted on{" "}
          <a
            href="https://keen-mirzakhani-beaf79.netlify.app"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Netlify
          </a>{" "}
          -
        </footer>
      </div>
    </div>
  );
}
